<template>
  <div class="about">
    <h1>You have successfully logged out.</h1>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import router from "../router";

export default defineComponent({
  name: "LogoutView",
  
  setup() {
    // Clear everything
    localStorage.clear();
    
    // 🔥🔥🔥 IMPORTANT: Dispatch event to update navbar 🔥🔥🔥
    window.dispatchEvent(new Event('login-status-changed'));
    
    // Redirect to login page
    router.push("/login");
  },
  
  mounted() {
    // Just in case, clear again and dispatch
    localStorage.clear();
    window.dispatchEvent(new Event('login-status-changed'));
  }
});
</script>

<style scoped>
.about {
  text-align: center;
  padding: 50px;
}
</style>